import React, { useState } from 'react';
import { FaPlus, FaMinus , FaCircleCheck } from 'react-icons/fa6';
import './WhyUs.scss';

interface Section {
  id: number;
  title: string;
  summary: string;
  details: string[];
}

const sections: Section[] = [
    {
      id: 1,
      title: 'Estás por abrir tu restaurante',
      summary: 'Factura desde el primer día',
      details: [
        'Interfaz clara y fácil de usar desde el inicio',
        'Cobros con tarjeta sin filas ni conciliaciones',
        'Integración inmediata con delivery y reservas',
        'Ventas y stock en tiempo real desde tu móvil',
      ],
    },
    {
      id: 2,
      title: 'Tu sistema actual te limita',
      summary: 'Una plataforma que escala contigo',
      details: [
        'Acceso remoto total desde cualquier dispositivo',
        'Soporte dedicado los 365 días del año',
        'Inventario, facturación y reportes en un solo lugar',
        'Sin cargos ocultos ni sorpresas',
      ],
    },
    {
      id: 3,
      title: 'Quieres digitalizar tu operación',
      summary: 'Automatiza o deja dinero en el camino',
      details: [
        'Visibilidad en tiempo real de toda tu operación',
        'Centraliza delivery, reservas y canales de venta',
        'Pagos y facturación QR automáticos',
        'API abierta para integrar tus herramientas',
      ],
    },
  ];

const WhyUs: React.FC = () => {
  const [openSections, setOpenSections] = useState<number[]>([]);

  const toggleSection = (id: number) => {
    setOpenSections(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  return (
    <section className="why-us">
      <span className="why-us__label">Tu punto de partida</span>
      <h2 className="why-us__title">¿En qué etapa está tu negocio?</h2>
      <p className="why-us__subtitle">
        Cada restaurante tiene un camino diferente. En <span>MedioPunto</span> nos adaptamos
        a tu realidad, sin importar en qué punto te encuentres.
      </p>
      <div className="why-us__cards">
        {sections.map(section => {
          const isOpen = openSections.includes(section.id);
          return (
            <div key={section.id} className={`card ${isOpen ? 'open' : ''}`}>
              <div
                className="card__header"
                onClick={() => toggleSection(section.id)}
              >
                <h3 className="card__title">{section.title}</h3>
                {isOpen ? <FaMinus className='icon'/> : <FaPlus className='icon'/>}
              </div>
              {isOpen && (
                <div className="card__content">
                  {section.summary && (
                    <p className="card__summary">{section.summary}</p>
                  )}
                  <ul className="card__list">
                    {section.details.map((item, idx) => (
                      <li key={idx}>
                        <FaCircleCheck className='check-icon'/>{item}
                        </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhyUs;
